export enum EOrderStatus {
    IN_PROGRESS = 'In Progress',
    DISPATCHED = 'Dispatched',
}
